import { render, staticRenderFns } from "./ProductionLoggerList.vue?vue&type=template&id=2909b33c&scoped=true"
import script from "./ProductionLoggerList.vue?vue&type=script&lang=js"
export * from "./ProductionLoggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909b33c",
  null
  
)

export default component.exports